// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:14:19.925Z
// Property: Legacy West (ID: 6767906449167227)
// Collections: 20 amenities, 2 floorplans (live), 12 photos, 75 POIs, 4 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167227",
  "property_external_id": "1101863",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/legacy-west-anchorage-ak/dmhm1nh/",
  "property_google_business_url": "https://www.google.com/maps/place/Legacy+West/data=!4m2!3m1!1s0x0:0x4435fbf1a86a684d?sa=X&ved=2ahUKEwiI_L_2kISTAxXpkJUCHeNiEHUQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47749960619",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "legacy-west",
  "property_name": "Legacy West",
  "property_website_url": "https://www.legacywestapartments.com",
  "property_domain": "https://www.legacywestapartments.com",
  "property_address": "141 Patterson St",
  "property_full_address": "141 Patterson St, Anchorage, AK 99504",
  "property_address_1": "141 Patterson St",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99504",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Northeast Anchorage",
  "property_address_latitude": "61.22309620000001",
  "property_address_longitude": "-149.7480701",
  "property_email": "thelegacy@weidner.com",
  "property_phone": "(907) 308-5343",
  "property_call_tracking_phone": "907-308-5343",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Room to breathe in Northeast Anchorage.</strong> Legacy West pairs spacious two- and three-bedroom layouts with everyday comforts, select mountain views, and streamlined service—explore current floor plans and find your next home base.</p>",
  "property_long_description": "<p><strong>Settle into a Northeast Anchorage address with room to breathe.</strong> At Legacy West, you’re close to the everyday conveniences of Muldoon while coming home to two- and three-bedroom layouts with practical comforts: in-home washer/dryer, dishwasher, dining room, large or walk-in closets, ceiling fans, and a fireplace for long Alaska evenings. Select homes add a patio or balcony and Chugach Mountain Range views, giving your space a clear connection to Anchorage’s best backdrop.</p><p>Beyond your front door, keyed building access, on-site management, 24-hour emergency maintenance, online payments and service requests, on-call security, smoke-free living, and convenient pet stations keep daily life streamlined. Explore current <a href=\"/floor-plans\">two- and three-bedroom floor plans</a>, then look around the area: Tikahtnu Commons brings shopping, dining, Target, Costco, Lowe’s, and Regal entertainment nearby, while Russian Jack Springs Park, Alaska Botanical Garden, Chugach State Park access, Providence Alaska Medical Center, ANMC, and downtown Anchorage are all within an easy East Anchorage routine.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc.webp",
  "property_featured_image_media": {
    "alt_text": "Clean kitchen with wooden cabinets, white appliances, and a sink.",
    "public_id": "01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc",
    "storage_key": "property/6767906449167227/01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.83333333333334",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://legacywestapartments.securecafe.com/onlineleasing/legacy-west-0/floorplans.aspx",
  "property_resident_portal_url": "https://legacywestapartments.securecafenet.com/residentservices/legacy-west-0/userlogin",
  "property_apply_now_url": "https://legacywestapartments.securecafe.com/onlineleasing/legacy-west-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0225-8726-72e8-86ac-948c3657e9b2.webp",
  "property_primary_logo_media": {
    "alt_text": "Legacy West Apartment Homes logo in black on white background.",
    "public_id": "019d0225-8726-72e8-86ac-948c3657e9b2",
    "storage_key": "property/6767906449167227/019d0225-8726-72e8-86ac-948c3657e9b2.webp",
    "width": 592,
    "height": 434
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0227-81df-72dc-add6-16db638973f0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Legacy West Apartment Homes logo",
    "public_id": "019d0227-81df-72dc-add6-16db638973f0",
    "storage_key": "property/6767906449167227/019d0227-81df-72dc-add6-16db638973f0.webp",
    "width": 592,
    "height": 434
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0227-8ca8-761b-b17b-c03308e98f70.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Legacy West Apartment Homes logo",
    "public_id": "019d0227-8ca8-761b-b17b-c03308e98f70",
    "storage_key": "property/6767906449167227/019d0227-8ca8-761b-b17b-c03308e98f70.webp",
    "width": 592,
    "height": 434
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#d3b069",
  "property_secondary_color": "#8f6d32",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae2d7",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 840",
  "property_sqft_min": "780",
  "property_sqft_max": "840",
  "property_price_range": "1250 - 1996",
  "property_price_min": "1250",
  "property_price_max": "1996",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/LegacyWestApartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmfUxOp2WyFYRTWhqqPH7NUQ",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Legacy West",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, Anchorage-ready.</strong> Legacy West keeps daily routines simple with in-home washer/dryer, dishwasher, large closets, and a cozy fireplace for cold Alaska nights. Step out to a patio or balcony, with select homes offering walk-in closets and Chugach Mountain Range views. Keyed building access, on-call security, online payments, on-site service teams, pet stations, and a smoke-free setting round out the experience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Legacy West.</strong> Explore two- and three-bedroom apartments in Northeast Anchorage with practical one-bath layouts, in-home washer/dryer, dishwasher, dining room, generous closet space, and a fireplace. Select homes add a patio or balcony, walk-in closets, preferred-floor placement, or Chugach Mountain Range views.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Legacy West.</strong> Preview bright kitchens with generous cabinetry, fireplace-centered living rooms, and bedrooms designed with clean lines and natural light. Outside, green lawns, trees, open walkways, and select Chugach Mountain Range views add depth to the Northeast Anchorage setting. Browse the gallery, then schedule a tour to see more in person.</p>",
  "property_home_neighborhood_blurb": "<p><strong>East Anchorage convenience, mountain-town energy.</strong> Legacy West places Muldoon Road dining, Tikahtnu Commons errands, movie nights, and Chanshtnu Muldoon Park within an easy routine. People Mover stops and quick Glenn Highway access keep Anchorage connections simple, while nearby retail, trails, parks, and everyday services add more ways to make the most of the neighborhood.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight a standout leasing experience.</strong> Reviews for Legacy West often call out attentive support from team members like Britany and Maggie, from clear answers and patient tours to move-in help that keeps the process feeling simple. Read the latest ratings to see what residents appreciate most about service, follow-through, and the welcoming experience at Legacy West.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out an East Anchorage routine with mountain-town energy.</strong> From Legacy West, Northeast Anchorage puts everyday stops and weekend plans within an easy orbit: Muldoon Road dining, errands at Tikahtnu Commons, a movie night, or a quick reset at Chanshtnu Muldoon Park. Nearby People Mover connections and access to the Glenn Highway help keep trips across Anchorage straightforward, while the area’s mix of retail, parks, trails, and local services gives each day plenty of options.</p><p>Use the interactive map to find coffee, groceries, restaurants, transit stops, and outdoor escapes close to home, then come back to a smoke-free community with practical comforts designed for Alaska living. Ready to see how the location fits your schedule? <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore the neighborhood in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Comfort that works as hard as your day.</strong> At Legacy West, the amenities are built around simple, useful upgrades: wash on your schedule with an in-home washer/dryer, load the dishwasher after dinner, and settle by the fireplace when Anchorage nights get cold. Large closets—plus walk-in options in select homes—keep the two- and three-bedroom layouts feeling organized, while a patio or balcony and select Chugach Mountain Range views add space to pause.</p><p>Daily routines stay easy with keyed building access, on-call security, online payments and service requests, and on-site management and maintenance teams backed by 24-hour emergency maintenance. Pet stations and a smoke-free community add thoughtful finishing touches. See more in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Legacy West home?</strong><br>Start your application online for a two- or three-bedroom apartment with practical comforts, streamlined services, and a Northeast Anchorage setting close to everyday conveniences. Your next address is within reach—apply now and take the next step.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Legacy West?</strong> Our leasing team is here to help with two- and three-bedroom availability, practical in-home comforts, and directions to our Northeast Anchorage community. Reach out today and let us make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Legacy West?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in Northeast Anchorage. From two- and three-bedroom layouts to service requests and pet stations, this FAQ is here to help—and the leasing team is happy to answer anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits how you live.</strong> Legacy West keeps the decision simple with two- and three-bedroom apartments in Northeast Anchorage, each with one bath and practical spaces that are easy to compare at a glance. As you browse the floor plan cards, look for everyday details that make a difference: an in-home washer/dryer, dishwasher, dining room, generous closet space, and a fireplace for added comfort.</p><p>Select homes add a patio or balcony, walk-in closets, Chugach Mountain Range views, or placement on your preferred floor, giving you room to prioritize what matters most. Review current pricing and availability, explore finishes on the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Legacy West from every angle.</strong> Browse photos that bring the details into focus: a bright kitchen with generous cabinetry, a carpeted living room anchored by a fireplace, and bedrooms with clean lines, natural light, and space to organize. Outside, green lawn, trees, and open walkways frame the community setting, while select views pull the Chugach Mountain Range into the picture.</p><p>As you click through the gallery, look for the everyday comforts that shape life here in Northeast Anchorage—patio or balcony moments, in-home laundry, and practical two- and three-bedroom layouts. Compare the images with our <a href=\"/floor-plans\">available floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Legacy West from the map.</strong> See available two- and three-bedroom apartments, then zoom out to the Northeast Anchorage conveniences, parks, medical centers, and everyday destinations that keep East Anchorage connected.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living, with the practical details close at hand.</strong> At Legacy West, your cat or dog has room in the routine—from open pet areas and conveniently placed pet stations to layouts that make everyday cleanup easier after snowy walks or muddy spring trails. In-home washer/dryer, large closets, and select patio or balcony space help keep leashes, towels, and pet gear organized without complicating your day.</p><p>When it’s time to get outside, Northeast Anchorage puts local paths and designated off-leash options within an easy drive, including fenced areas at Chanshtnu Muldoon Park. Review the pet policy below for limits and fees, then explore <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Legacy West fits your daily walks.</p>",
  "property_referafriend_blurb": "<p><strong>Share the room to breathe.</strong> Love your Northeast Anchorage address? Invite a friend to discover Legacy West’s spacious two- and three-bedroom layouts, practical in-home comforts, and easy access to everyday conveniences. Send a referral today and help them find their next apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong> Log in to pay rent online, submit service requests, and manage your Legacy West account from one convenient place. For urgent needs, 24-hour emergency maintenance and on-site management help keep daily life streamlined.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out at Legacy West.</strong> In resident reviews, the leasing experience gets the spotlight—especially the attentive support from team members like Britany and Maggie.</p><p>You’ll read about helpful, accommodating service, clear information, patient apartment tours, and move-in support that made the process feel easier from the first call to getting settled. One reviewer described a <strong>“warm and welcoming personality”</strong>, while another praised the team’s professionalism and follow-through. Browse the latest ratings to hear directly from residents about their experience at Legacy West.</p>",
  "property_created_at": "1771540918942",
  "property_scheduletour_blurb": "<p><strong>See the space that fits your Anchorage routine.</strong> Tour Legacy West and get a feel for roomy two- and three-bedroom <a href=\"/floor-plans\">floor plans</a>, practical in-home comforts, and select mountain-view patios or balconies. Schedule your visit today and picture coming home to Northeast Anchorage with room to breathe.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Legacy West’s leasing team will follow up soon. In the meantime, picture everyday ease in Northeast Anchorage with spacious two- and three-bedroom layouts, in-home comforts, and a connected location near Muldoon conveniences.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layout before you visit.</strong> Step inside Legacy West’s virtual tours and get a clear feel for the 2x1 and 3x1 apartments in Anchorage from wherever you are. Move through the kitchen, dining area, living room, bedrooms, and bath at your own pace, noting practical details like in-home laundry, a fireplace, generous closet space, and the flow to a patio or balcony in select homes. The 2x1 tour helps you picture everyday organization, while the 3x1 tour gives you a closer look at the added room to spread out. Compare what you see with current <a href=\"/floor-plans\">floor plan availability</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready for the in-person view.</p>",
  "property_copyright": "2026 All Rights Reserved. Legacy West",
  "property_seo_title_home": "Relaxed Living - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_home": "Find your space at Legacy West in Anchorage, AK. Enjoy in-home laundry, pet-friendly living, and easy access to dining and shopping.",
  "property_seo_title_floorplans": "Spacious Floor Plans - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_floorplans": "View two- and three-bedroom floor plans at Legacy West in Anchorage, AK. Find your fit with roomy closets, private balconies, and in-home laundry.",
  "property_seo_title_amenities": "Features & Amenities - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_amenities": "See all amenities at Legacy West including pet stations, fireplaces, balconies, in-home laundry, and mountain views in Anchorage, AK.",
  "property_seo_title_gallery": "Photo Gallery - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_gallery": "See real photos of Legacy West - bright apartments, open kitchens, green space, and Chugach mountain views in Anchorage, AK.",
  "property_seo_title_virtualtours": "Virtual Tour - Legacy West Apartment Homes - Anchorage, AK",
  "property_seo_description_virtualtours": "Take a virtual tour of Legacy West in Anchorage, AK. Picture life from home with immersive, online viewing.",
  "property_seo_title_interactivemap": "Interactive Map | Legacy West Apartments",
  "property_seo_description_interactivemap": "Discover your ideal Anchorage retreat at Legacy West! Enjoy spacious two and three-bedroom plans with stunning views and modern amenities.",
  "property_seo_title_neighborhood": "Neighborhood - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_neighborhood": "Discover the East Anchorage neighborhood near Target, Century 16, and mountain views at Legacy West Apartments.",
  "property_seo_title_contact": "Contact Legacy West Apartment Homes - Anchorage, AK",
  "property_seo_description_contact": "Reach out to Legacy West Apartments in Anchorage, AK. Our leasing team is here to help you learn more about your new home.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers to your questions about Legacy West in Anchorage, AK! Discover our amenities, floor plans, and everything that makes our community unique.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "At Legacy West in Anchorage, our residents share their experiences living amid stunning mountain views and top-notch amenities. Dive into their stories!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Discover your perfect home at Legacy West in Anchorage! Enjoy spacious 2 & 3-bedroom apartments with amazing Chugach Mountain views. Apply today!",
  "property_seo_title_residentaccess": "Resident Access | Legacy West",
  "property_seo_description_residentaccess": "Unlock seamless living at Legacy West in Anchorage! Log in to your resident portal for rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Legacy West",
  "property_seo_description_referafriend": "Refer a friend to Legacy West in Anchorage! Great friends make great neighbors—share the joy of our vibrant community and enjoy exclusive perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour - Legacy West Apartments - Anchorage, AK",
  "property_seo_description_scheduletour": "Schedule your tour of Legacy West Apartments in Anchorage, AK. Choose live virtual, in-person, or guided tour options.",
  "property_seo_title_privacy": "Privacy Policy | Legacy West",
  "property_seo_description_privacy": "At Legacy West in Anchorage, AK, your privacy matters. Uncover how we safeguard your information with our transparent privacy practices. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Legacy West",
  "property_seo_description_accessibility": "At Legacy West in Anchorage, AK, we promote accessibility for all, creating a community of digital inclusion for a vibrant lifestyle.",
  "property_seo_title_sitemap": "Sitemap | Legacy West",
  "property_seo_description_sitemap": "Navigate Legacy West in Anchorage, AK! Our sitemap makes it easy to explore vibrant living options, amenities, and community details. Your new home awaits!",
  "property_seo_title_thankyou": "Thank You | Legacy West",
  "property_seo_description_thankyou": "Thank you for reaching out to Legacy West in Anchorage! Our team will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791326791132",
  "amenities": [
    {
      "id": "ec_ebcd21860512ca94fa88141f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455678",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_deee4fe9d2d5589dc4abeaad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455680",
      "title": "Keyed Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b890f2f75633836a61b5b3c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455682",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7721e49387bd864c59790ace",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455683",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17d2bac477e5039c517c4d4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "90508447",
      "title": "On-Call Security",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be99c4f823438dce3763db2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455685",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b1a8e6f95490f004a14a6de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455686",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a32abc42c640457ba7f4293f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "90508451",
      "title": "Conveniently Located Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64d197250273fd1052fb01f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455695",
      "title": "In-Home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d9a3a-96ac-7509-aed7-b5154b1eb8ad.webp",
      "amenity_image_media": {
        "alt_text": "Stackable washer and dryer next to a closet and a bathroom with a vanity, toilet, and mirror.",
        "public_id": "019d9a3a-96ac-7509-aed7-b5154b1eb8ad",
        "storage_key": "property/6767906449167227/019d9a3a-96ac-7509-aed7-b5154b1eb8ad.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Legacy West Apartments - Laundry and Bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_002070bcb3b90b91d0a41fe5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455687",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d9a3a-9703-723d-af0c-622e31756fa4.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and living room in an apartment.",
        "public_id": "019d9a3a-9703-723d-af0c-622e31756fa4",
        "storage_key": "property/6767906449167227/019d9a3a-9703-723d-af0c-622e31756fa4.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Legacy West Apartments - Kitchen and Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40c897440f3efebca2b14920",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455688",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0adf4-affb-76a0-8874-8a58204d3052.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wood cabinets, double sink, dishwasher, and window.",
        "public_id": "01a0adf4-affb-76a0-8874-8a58204d3052",
        "storage_key": "property/6767906449167227/01a0adf4-affb-76a0-8874-8a58204d3052.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Legacy West Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9b9649e6ad8803893680bd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455690",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d9a3a-9631-7170-b14e-cbdfb853175e.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace and balcony access.",
        "public_id": "019d9a3a-9631-7170-b14e-cbdfb853175e",
        "storage_key": "property/6767906449167227/019d9a3a-9631-7170-b14e-cbdfb853175e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Legacy West Apartments - Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_999c613424d0f03ed2702c4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455692",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bf7324073ee04749f9c575c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455693",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b50f440e9de7810a5ae245d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455697",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2655032c6bf6b5f02601ff72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "87455699",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a82a452f9e30d74f6f9b55b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "90508453",
      "title": "Views of the Chugach Mountain Range*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59c0f82d0cea4d244fd202d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "127829859",
      "title": "Ground Floor",
      "amount": "false",
      "description": "Ground Floor",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dcecff9c6dbc07a9c770154",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "127829860",
      "title": "Middle Floor",
      "amount": "false",
      "description": "Middle Floor",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bd51820f5f1d56e39986330",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "external_id": "127829861",
      "title": "Top Floor",
      "amount": "false",
      "description": "Top Floor",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_59dd6f6e8598f10741aa9feb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc.webp",
      "image_media": {
        "alt_text": "Clean kitchen with wooden cabinets, white appliances, and a sink.",
        "public_id": "01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc",
        "storage_key": "property/6767906449167227/01a0a8f3-c5f6-71cc-be84-d3b7f27b7ccc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bright kitchen features ample storage with beautiful wooden cabinets and efficient white appliances, including a stove, refrigerator, and dishwasher.",
      "link": "false",
      "alt_text": "Clean kitchen with wooden cabinets, white appliances, and a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (35).jpg"
    },
    {
      "id": "ec_db0bc62b425a98236159e30b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-ad06-749e-9dce-43a34ccaa70c.webp",
      "image_media": {
        "alt_text": "Kitchen area with wood cabinets, double sink, and refrigerator, opens to living room.",
        "public_id": "01a0a8f3-ad06-749e-9dce-43a34ccaa70c",
        "storage_key": "property/6767906449167227/01a0a8f3-ad06-749e-9dce-43a34ccaa70c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Functional kitchen with ample cabinet space and a double sink, seamlessly flowing into the living area.",
      "link": "false",
      "alt_text": "Kitchen area with wood cabinets, double sink, and refrigerator, opens to living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (37).jpg"
    },
    {
      "id": "ec_dd51be3e487ad2726a2598ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-fab5-778a-b59d-7f96cb386ff7.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, double sink, refrigerator, and window.",
        "public_id": "01a0a8f3-fab5-778a-b59d-7f96cb386ff7",
        "storage_key": "property/6767906449167227/01a0a8f3-fab5-778a-b59d-7f96cb386ff7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring ample wood cabinetry, granite countertops, a double sink, and a window for natural light.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, granite countertops, double sink, refrigerator, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (32).jpg"
    },
    {
      "id": "ec_dce1d3ea22e9ab9cb863062a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f4-2552-7209-a906-04c6840792ab.webp",
      "image_media": {
        "alt_text": "Empty living room with beige carpet and a window view of the exterior.",
        "public_id": "01a0a8f4-2552-7209-a906-04c6840792ab",
        "storage_key": "property/6767906449167227/01a0a8f4-2552-7209-a906-04c6840792ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring plush beige carpeting, a large window with blinds, and a decorative vase with yellow flowers on a side table.",
      "link": "false",
      "alt_text": "Empty living room with beige carpet and a window view of the exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (30).jpg"
    },
    {
      "id": "ec_4d591afe664d5496b0b46b0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f4-5c03-7659-a940-6c3807f8f1c5.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-sized bed, nightstands, and a window.",
        "public_id": "01a0a8f4-5c03-7659-a940-6c3807f8f1c5",
        "storage_key": "property/6767906449167227/01a0a8f4-5c03-7659-a940-6c3807f8f1c5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our beautifully appointed bedrooms, featuring plush bedding and ample natural light.",
      "link": "false",
      "alt_text": "A cozy bedroom with a queen-sized bed, nightstands, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (25).jpg"
    },
    {
      "id": "ec_6b3258da5728a313b0d5ebd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f4-08d3-7028-bee4-86fde3ce57ca.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
        "public_id": "01a0a8f4-08d3-7028-bee4-86fde3ce57ca",
        "storage_key": "property/6767906449167227/01a0a8f4-08d3-7028-bee4-86fde3ce57ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a white tiled bathtub and shower, a toilet, and a wooden vanity with a granite countertop, sink, and mirror.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (34).jpg"
    },
    {
      "id": "ec_97ecc1c10df58254f5fbeebc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f4-0675-70eb-8210-1a520f7fdf7c.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "01a0a8f4-0675-70eb-8210-1a520f7fdf7c",
        "storage_key": "property/6767906449167227/01a0a8f4-0675-70eb-8210-1a520f7fdf7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean apartment bathroom featuring a bathtub, toilet, and spacious vanity with ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (33).jpg"
    },
    {
      "id": "ec_71d5151c3474244d77225180",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-707a-7559-9449-1fedee21f49b.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking residential street and trees.",
        "public_id": "01a0a8f3-707a-7559-9449-1fedee21f49b",
        "storage_key": "property/6767906449167227/01a0a8f3-707a-7559-9449-1fedee21f49b.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy the fresh air and scenic views from your private balcony. This outdoor space offers a peaceful retreat overlooking the surrounding neighborhood and lush trees.",
      "link": "false",
      "alt_text": "View from balcony overlooking residential street and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (41).jpg"
    },
    {
      "id": "ec_17cab1c41a4da3115240d970",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-1780-701b-932b-41d278aa8ae1.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with leasing office sign and balloons.",
        "public_id": "01a0a8f3-1780-701b-932b-41d278aa8ae1",
        "storage_key": "property/6767906449167227/01a0a8f3-1780-701b-932b-41d278aa8ae1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community! The leasing office is ready to assist you. Exterior view of building entrance with festive balloons.",
      "link": "false",
      "alt_text": "Exterior building entrance with leasing office sign and balloons.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (43).jpg"
    },
    {
      "id": "ec_55291741fda12370a339982a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-577d-702f-ba9d-4f9440cf67c5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with parking lot and trees.",
        "public_id": "01a0a8f3-577d-702f-ba9d-4f9440cf67c5",
        "storage_key": "property/6767906449167227/01a0a8f3-577d-702f-ba9d-4f9440cf67c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment building exterior showcasing its design and surrounding landscape. Features a parking lot and green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with parking lot and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (42).jpg"
    },
    {
      "id": "ec_ec5cfcfe3a6086c1d14b3c29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-4858-7570-bd07-e2f2bdc7c46a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a parking lot.",
        "public_id": "01a0a8f3-4858-7570-bd07-e2f2bdc7c46a",
        "storage_key": "property/6767906449167227/01a0a8f3-4858-7570-bd07-e2f2bdc7c46a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing balconies and ample parking space under a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Alaska_Legacy-West_Exterior_Building (7).jpg"
    },
    {
      "id": "ec_618417438d2edba4b9fdc9ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/01a0a8f3-aef5-7247-82f7-7c91ba056187.webp",
      "image_media": {
        "alt_text": "Apartment building with covered parking and balconies under a cloudy sky.",
        "public_id": "01a0a8f3-aef5-7247-82f7-7c91ba056187",
        "storage_key": "property/6767906449167227/01a0a8f3-aef5-7247-82f7-7c91ba056187.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring covered parking spaces and private balconies, set against a dramatic cloudy sky.",
      "link": "false",
      "alt_text": "Apartment building with covered parking and balconies under a cloudy sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Legacy-West_Favorites (39).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2533ab73-2687-4f1a-a8bd-0626f4d4a273",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Firetap Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "10950 O'Malley Centre Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "Inventive pizzas, plus pasta & sandwiches, in a relaxed, spacious spot with dozens of craft beers.",
      "poi_long_description": "Inventive pizzas, plus pasta & sandwiches, in a relaxed, spacious spot with dozens of craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-2df5-772f-866a-a7c31289ee5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-2df5-772f-866a-a7c31289ee5b",
        "storage_key": "property/6767906449167227/019d0226-2df5-772f-866a-a7c31289ee5b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://firetapalehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6345634015277194483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firetap-alehouse",
      "poi_latitude": "61.121792",
      "poi_longitude": "-149.862508",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 907-561-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5xVnJWZyFYR85w7K4Q4EFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_69506bbc-e38f-42ad-8ac8-3749697c86cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Great Alaska Pizza Co",
      "poi_type": "Restaurants",
      "poi_address": "6311 DeBarr Rd S, Anchorage, AK 99504, USA",
      "poi_short_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_long_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-2910-77ed-b915-4be497f285e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-2910-77ed-b915-4be497f285e3",
        "storage_key": "property/6767906449167227/019d0226-2910-77ed-b915-4be497f285e3.webp",
        "width": 819,
        "height": 545
      },
      "poi_business_url": "http://www.greatalaskapizzacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12977148615757751787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-alaska-pizza-co",
      "poi_latitude": "61.2101628",
      "poi_longitude": "-149.7619934",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-337-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxhC0ZOWyFYR62Wx_-gXGLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_0b3bc58b-554d-4acc-addc-490030ef34db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "1106 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-2a91-7024-9fe2-0d709796ed8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-2a91-7024-9fe2-0d709796ed8a",
        "storage_key": "property/6767906449167227/019d0226-2a91-7024-9fe2-0d709796ed8a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/ak/anchorage/breakfast-1106-north-muldoon-rd-3291?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=3291&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1800792664124623868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "61.2262005",
      "poi_longitude": "-149.7428446",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-332-4467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZp_Vi-UyFYR_AtHE2Oz_Rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_0a55fffe-1b01-444a-b682-af14a4e69549",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "1102 N Muldoon Rd Ste A4, Anchorage, AK 99504, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-2a3a-7074-b26f-4f9e7e85e91a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-2a3a-7074-b26f-4f9e7e85e91a",
        "storage_key": "property/6767906449167227/019d0226-2a3a-7074-b26f-4f9e7e85e91a.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "https://locations.qdoba.com/us/ak/anchorage/1102-n-muldoon-rd?utm_medium=organic&utm_source=google&utm_campaign=google_maps&utm_content=website&utm_term=2425",
      "poi_directions_map_url": "https://maps.google.com/?cid=17485879173536694150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "61.2270315",
      "poi_longitude": "-149.7395751",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-339-9611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm5UpMqOWyFYRhj8O1HZSqvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_43d7ff86-7164-4d5a-b458-8a813e488e01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Wild Wings 'n Things",
      "poi_type": "Restaurants",
      "poi_address": "1102 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Simple destination for comfort food ranging from wings & wraps to sliders & cheesesteaks.",
      "poi_long_description": "Simple destination for comfort food ranging from wings & wraps to sliders & cheesesteaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-2ef6-76ac-bd39-245d7c36c090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-2ef6-76ac-bd39-245d7c36c090",
        "storage_key": "property/6767906449167227/019d0226-2ef6-76ac-bd39-245d7c36c090.webp",
        "width": 508,
        "height": 300
      },
      "poi_business_url": "http://www.wildwingsak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1232773972680788664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wild-wings-n-things",
      "poi_latitude": "61.2271077",
      "poi_longitude": "-149.739561",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-694-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_ihiyiUyFYRuEr8iWWxGxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_f60f4534-d622-477f-bbbc-960b24daa7af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Pho Saigon",
      "poi_type": "Restaurants",
      "poi_address": "1118 N Muldoon Rd #135, Anchorage, AK 99504, USA",
      "poi_short_description": "Casual, cozy Vietnamese establishment offering pho and other staples such as vermicelli and banh mi sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-31c4-7338-bcad-a660ff34b83c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-31c4-7338-bcad-a660ff34b83c",
        "storage_key": "property/6767906449167227/019d0226-31c4-7338-bcad-a660ff34b83c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.phosaigonak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6038020422487766607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-saigon",
      "poi_latitude": "61.22755739999999",
      "poi_longitude": "-149.7428651",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-222-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ckjySeUyFYRT_bvXJVby1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_0230a959-a98a-45f8-8a05-778806d4da8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Pita Pit",
      "poi_type": "Restaurants",
      "poi_address": "1130 N Muldoon Rd Suite 100, Anchorage, AK 99504, USA",
      "poi_short_description": "Diners create their own sandwiches at this health-oriented counter-serve chain.",
      "poi_long_description": "Diners create their own sandwiches at this health-oriented counter-serve chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-31b1-778f-a422-e7c034c8a152.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-31b1-778f-a422-e7c034c8a152",
        "storage_key": "property/6767906449167227/019d0226-31b1-778f-a422-e7c034c8a152.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://locations.pitapitusa.com/locations/ak/anchorage/1130-north-muldoon-road-suite-100",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944353834667938307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pita-pit",
      "poi_latitude": "61.2282759",
      "poi_longitude": "-149.7415043",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-338-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO15Y_yWUyFYRAxK9qe5LhME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_56d8c3fc-cd1f-4b68-bbad-dfa2e035435d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Kenny's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1118 N Muldoon Rd #125, Anchorage, AK 99504, USA",
      "poi_short_description": "This cheerful Asian restaurant serves familiar Chinese dishes plus Japanese options like teriyaki.",
      "poi_long_description": "This cheerful Asian restaurant serves familiar Chinese dishes plus Japanese options like teriyaki.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-34a1-709b-bd3e-0744f7e7814c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-34a1-709b-bd3e-0744f7e7814c",
        "storage_key": "property/6767906449167227/019d0226-34a1-709b-bd3e-0744f7e7814c.webp",
        "width": 1259,
        "height": 1280
      },
      "poi_business_url": "https://kennyskitchenanc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14455532397694959286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennys-kitchen",
      "poi_latitude": "61.2276742",
      "poi_longitude": "-149.7428406",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-338-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe5pkieUyFYRtj7CgyBenMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_678645fd-4373-4b50-bb42-02e13978bd67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1142 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-34a2-701d-966a-5ae939ad6548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-34a2-701d-966a-5ae939ad6548",
        "storage_key": "property/6767906449167227/019d0226-34a2-701d-966a-5ae939ad6548.webp",
        "width": 1280,
        "height": 920
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/113324/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2330391584122600636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "61.22871",
      "poi_longitude": "-149.74249",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-338-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b399-7661-a159-332eb3c0784f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b399-7661-a159-332eb3c0784f",
        "storage_key": "property/6767906449167227/019d0226-b399-7661-a159-332eb3c0784f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJY95WvSeUyFYRvPwvf8w2VyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_f640d6c4-a1c6-469e-a4ef-47a90bf09eff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-372b-74e1-920f-af7f909d2b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-372b-74e1-920f-af7f909d2b66",
        "storage_key": "property/6767906449167227/019d0226-372b-74e1-920f-af7f909d2b66.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a2551a02-5a64-4a50-8934-fef7f13d4973",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-383d-760c-92d7-7c0edef47e09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-383d-760c-92d7-7c0edef47e09",
        "storage_key": "property/6767906449167227/019d0226-383d-760c-92d7-7c0edef47e09.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b399-7661-a159-332eb3c0784f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b399-7661-a159-332eb3c0784f",
        "storage_key": "property/6767906449167227/019d0226-b399-7661-a159-332eb3c0784f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_70cd100c-a51a-47ab-987b-cc643df3373d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-3d1d-7734-89a4-7fc5652e3003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-3d1d-7734-89a4-7fc5652e3003",
        "storage_key": "property/6767906449167227/019d0226-3d1d-7734-89a4-7fc5652e3003.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b399-7661-a159-2bb3a2e4629f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b399-7661-a159-2bb3a2e4629f",
        "storage_key": "property/6767906449167227/019d0226-b399-7661-a159-2bb3a2e4629f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_238784f1-b3ed-41e9-a61e-5123fa398a53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Orso",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_long_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-3d1e-746e-9520-158d3b382860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-3d1e-746e-9520-158d3b382860",
        "storage_key": "property/6767906449167227/019d0226-3d1e-746e-9520-158d3b382860.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orsoalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688852827403958754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orso",
      "poi_latitude": "61.2176833",
      "poi_longitude": "-149.8961662",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-222-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYR4rlzElC4dYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_d08ad1a1-a359-4246-a137-ccaec46b11c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Simon & Seafort's Saloon & Grill",
      "poi_type": "Restaurants",
      "poi_address": "420 L St, Anchorage, AK 99501, USA",
      "poi_short_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_long_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-401a-7109-b7c1-379e1ea68a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-401a-7109-b7c1-379e1ea68a67",
        "storage_key": "property/6767906449167227/019d0226-401a-7109-b7c1-379e1ea68a67.webp",
        "width": 600,
        "height": 441
      },
      "poi_business_url": "https://www.simonandseaforts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1709221909627021300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simon--seaforts-saloon--grill",
      "poi_latitude": "61.2179842",
      "poi_longitude": "-149.9043854",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b366-70c8-a182-006db5008737",
        "storage_key": "property/6767906449167227/019d0226-b366-70c8-a182-006db5008737.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5_VXoG9yFYR9CeiXUVguBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e37f0978-baed-41e2-8b03-2761e2c73881",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 N Muldoon Rd Ste F, Anchorage, AK 99504, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4119-756c-a043-200bd9235591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4119-756c-a043-200bd9235591",
        "storage_key": "property/6767906449167227/019d0226-4119-756c-a043-200bd9235591.webp",
        "width": 1280,
        "height": 981
      },
      "poi_business_url": "https://www.target.com/sl/anchorage-ne/2371",
      "poi_directions_map_url": "https://maps.google.com/?cid=4266841454106128535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "61.2262581",
      "poi_longitude": "-149.7467627",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-269-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ50LtKyaUyFYRlzDoILLdNjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c65b5a94-88b5-4640-9b7b-8a0aebcc59d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4302-77fc-875f-5e6d00c66bd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4302-77fc-875f-5e6d00c66bd9",
        "storage_key": "property/6767906449167227/019d0226-4302-77fc-875f-5e6d00c66bd9.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/muldoon/701/00018?cid=loc_70100018_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6875232166619000959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.2115208",
      "poi_longitude": "-149.7367644",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-269-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b7b9-70aa-a728-13364748ec7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b7b9-70aa-a728-13364748ec7c",
        "storage_key": "property/6767906449167227/019d0226-b7b9-70aa-a728-13364748ec7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1aeEJaOWyFYRfzCqnzq7aV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0896fa8e-0d88-494a-9188-474a81a44d50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7405 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Discount superstore stocked with food, clothing, home furnishings and electronics, along with a pharmacy, deli and bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4301-770c-bc24-738ae5d168e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4301-770c-bc24-738ae5d168e1",
        "storage_key": "property/6767906449167227/019d0226-4301-770c-bc24-738ae5d168e1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4359-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18253871179416217585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.2118328",
      "poi_longitude": "-149.7435267",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-339-9039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI7PFF5iWyFYR8SfY4B_HUv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e084bc2a-7f51-4bd0-9cdd-4cef0bc0e004",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "4125 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-45bb-734d-b14d-e47ea268ccef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-45bb-734d-b14d-e47ea268ccef",
        "storage_key": "property/6767906449167227/019d0226-45bb-734d-b14d-e47ea268ccef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/anchorage-AK-63.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167457813750908994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.2109639",
      "poi_longitude": "-149.8048228",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-269-9510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoYf74l6WyFYRQojUezQ2l1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_6775fbcd-f848-47f1-81ba-157bed0f6c96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "7731 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-47c8-7638-a302-7f3eff11f148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-47c8-7638-a302-7f3eff11f148",
        "storage_key": "property/6767906449167227/019d0226-47c8-7638-a302-7f3eff11f148.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/7731-e-northern-lights-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4251481625073218317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.1966254",
      "poi_longitude": "-149.7363264",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-339-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b7b9-70aa-a728-13364748ec7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b7b9-70aa-a728-13364748ec7c",
        "storage_key": "property/6767906449167227/019d0226-b7b9-70aa-a728-13364748ec7c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0KE4seWyFYRDfOWPwNMADs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a787bd44-0341-40bc-a7d1-975671222f8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "TIkahtnu Commons, 1200 N Muldoon Rd G, Anchorage, AK 99504, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4849-751a-967f-14f83e66c888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4849-751a-967f-14f83e66c888",
        "storage_key": "property/6767906449167227/019d0226-4849-751a-967f-14f83e66c888.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ak/anchorage/1200-n-muldoon-rd-1760.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=15670492686832680231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "61.2255759",
      "poi_longitude": "-149.7463125",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-677-5099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvwOC3yeUyFYRJ70EphLGeNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_78fd59ce-761c-4028-aee6-699f64b88ac3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 N Muldoon Rd D, Anchorage, AK 99504, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4a00-7059-b505-f604cac7d578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4a00-7059-b505-f604cac7d578",
        "storage_key": "property/6767906449167227/019d0226-4a00-7059-b505-f604cac7d578.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ak/anchorage-1325.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4708746175761966442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "61.228003",
      "poi_longitude": "-149.7469334",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-337-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvwOC3yeUyFYRamXF57LTWEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7c0852ae-82e4-4e07-a6ed-2e6d524f71d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4c9c-724a-8d48-3d5b7d96ddac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4c9c-724a-8d48-3d5b7d96ddac",
        "storage_key": "property/6767906449167227/019d0226-4c9c-724a-8d48-3d5b7d96ddac.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/AK-Anchorage/2955?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2955-_-na-_-0-_-0&y_source=1_MTE4NDMzNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5609176981201015203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "61.230445",
      "poi_longitude": "-149.738842",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-269-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN-ud4SWUyFYRo9HI5r7M100",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_641c6a00-08c3-40c0-a6fa-a9ff337324b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "285 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_long_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4ea8-72b6-a312-9bcb352cc7ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4ea8-72b6-a312-9bcb352cc7ba",
        "storage_key": "property/6767906449167227/019d0226-4ea8-72b6-a312-9bcb352cc7ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/285-muldoon-rd/2746631?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11474064356319902708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.2209215",
      "poi_longitude": "-149.7324712",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-333-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-6eb0c0fc8c7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-6eb0c0fc8c7a",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-6eb0c0fc8c7a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJCSKJyJ-WyFYR9DtraL0QPJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b9920755-549f-474b-bd6f-3137b0e100a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Andy's Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "240 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-4eab-75d8-a1ea-6b0b29fd08f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-4eab-75d8-a1ea-6b0b29fd08f7",
        "storage_key": "property/6767906449167227/019d0226-4eab-75d8-a1ea-6b0b29fd08f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.andysace.com/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=09645",
      "poi_directions_map_url": "https://maps.google.com/?cid=6694783377196962843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-ace-hardware",
      "poi_latitude": "61.2213053",
      "poi_longitude": "-149.7347489",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-333-6648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b4fd-7119-ae4f-d33512b688c8",
        "storage_key": "property/6767906449167227/019d0226-b4fd-7119-ae4f-d33512b688c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0x7LS56WyFYRG9QD1gKm6Fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_baa2d967-317e-47ad-8f82-061bee1df840",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Chester Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "1751 Patterson St, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/chestervalley",
      "poi_directions_map_url": "https://maps.google.com/?cid=3310440647395539596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chester-valley-elementary-school",
      "poi_latitude": "61.20456009999999",
      "poi_longitude": "-149.7477378",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-0335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD3r1Qb6WyFYRjHoGtjoM8S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_48cf172b-161b-4eb2-b96c-06f7f889406d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Scenic Park Elementary School",
      "poi_type": "Education",
      "poi_address": "3933 Patterson St, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-528d-711a-b492-105e1f5433af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-528d-711a-b492-105e1f5433af",
        "storage_key": "property/6767906449167227/019d0226-528d-711a-b492-105e1f5433af.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/scenicpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=1609349526021428072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scenic-park-elementary-school",
      "poi_latitude": "61.18525899999999",
      "poi_longitude": "-149.746988",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-742-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvVq5KNCWyFYRaFPzAd6OVRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6a202be8-ff29-4527-8c91-8e74550394c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Baxter Elementary School",
      "poi_type": "Education",
      "poi_address": "2991 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.asdk12.org/baxter",
      "poi_directions_map_url": "https://maps.google.com/?cid=15372340589429415811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baxter-elementary-school",
      "poi_latitude": "61.1932146",
      "poi_longitude": "-149.7617574",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx4XC9sKWyFYRg19C51GGVdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1f4be873-f8b9-446f-a216-5994db559123",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Ptarmigan Elementary School",
      "poi_type": "Education",
      "poi_address": "888 Edward St, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-558c-729e-a56c-e192a7329eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-558c-729e-a56c-e192a7329eb6",
        "storage_key": "property/6767906449167227/019d0226-558c-729e-a56c-e192a7329eb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/ptarmigan",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593156068931633944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ptarmigan-elementary-school",
      "poi_latitude": "61.21426769999999",
      "poi_longitude": "-149.7648965",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-aC30o-WyFYRGIMpjOoFQXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2e19b8b6-ea59-43e9-891b-73c683fac28a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Begich Middle School",
      "poi_type": "Education",
      "poi_address": "7440 Creekside Center Drive, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-54f8-759b-9b82-09108edffd68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-54f8-759b-9b82-09108edffd68",
        "storage_key": "property/6767906449167227/019d0226-54f8-759b-9b82-09108edffd68.webp",
        "width": 960,
        "height": 637
      },
      "poi_business_url": "https://www.asdk12.org/begich",
      "poi_directions_map_url": "https://maps.google.com/?cid=7141988370800961682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "begich-middle-school",
      "poi_latitude": "61.2080642",
      "poi_longitude": "-149.7430092",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjWKGIJaWyFYRkuiPV5VwHWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6b34d1aa-36d7-4c51-9a1f-c4c5be3e7b63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Bartlett High School",
      "poi_type": "Education",
      "poi_address": "1101 Golden Bear Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5605-74c4-854d-23659b674f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-5605-74c4-854d-23659b674f1e",
        "storage_key": "property/6767906449167227/019d0226-5605-74c4-854d-23659b674f1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/bartlett",
      "poi_directions_map_url": "https://maps.google.com/?cid=846529779845035471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bartlett-high-school",
      "poi_latitude": "61.23201479999999",
      "poi_longitude": "-149.7334114",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5cL-SWUyFYRz_Vzg1l6vws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e13e980b-febe-4c64-8e21-9f62ecae9718",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Anchorage Waldorf School",
      "poi_type": "Education",
      "poi_address": "3250 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5a47-7734-bc52-c11a204b257f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-5a47-7734-bc52-c11a204b257f",
        "storage_key": "property/6767906449167227/019d0226-5a47-7734-bc52-c11a204b257f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://waldorfak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18361981143723653720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-waldorf-school",
      "poi_latitude": "61.191018",
      "poi_longitude": "-149.764458",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-333-9062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQvwMt2WyFYRWLoRdJDc0v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_09d943b2-f574-4656-a17c-6333f7ffb22b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Mountain City Christian Academy",
      "poi_type": "Education",
      "poi_address": "6575 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5d10-754b-a4eb-e6094ac70a9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-5d10-754b-a4eb-e6094ac70a9e",
        "storage_key": "property/6767906449167227/019d0226-5d10-754b-a4eb-e6094ac70a9e.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.mountaincitychristian.academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14343842628401888106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-city-christian-academy",
      "poi_latitude": "61.1963032",
      "poi_longitude": "-149.7584713",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-337-9575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____z-SyFYRavv_o9-QD8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a17319af-d851-4fb2-9597-f642487be1c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5ca1-73f2-a531-e06d3470082e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-5ca1-73f2-a531-e06d3470082e",
        "storage_key": "property/6767906449167227/019d0226-5ca1-73f2-a531-e06d3470082e.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_efc5f3cc-4cbe-4f03-8920-69e5b3ddb9bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-5f7a-7603-8dcb-35408a00d700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-5f7a-7603-8dcb-35408a00d700",
        "storage_key": "property/6767906449167227/019d0226-5f7a-7603-8dcb-35408a00d700.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_fcf8c2b8-d8fb-4149-ae86-8106686476bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-626c-767a-a35d-da111e4e72c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-626c-767a-a35d-da111e4e72c9",
        "storage_key": "property/6767906449167227/019d0226-626c-767a-a35d-da111e4e72c9.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bbf2-740f-bffe-d92940e5a4d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bbf2-740f-bffe-d92940e5a4d6",
        "storage_key": "property/6767906449167227/019d0226-bbf2-740f-bffe-d92940e5a4d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_af8e3ad4-bcf0-40b6-a47c-4bcdff0a90d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-64a2-758f-9718-347b790833d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-64a2-758f-9718-347b790833d8",
        "storage_key": "property/6767906449167227/019d0226-64a2-758f-9718-347b790833d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdc1-72df-948e-4b7cdf1137d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdc1-72df-948e-4b7cdf1137d9",
        "storage_key": "property/6767906449167227/019d0226-bdc1-72df-948e-4b7cdf1137d9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_897e8e98-dbb3-4a12-89ad-edcaea8853a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-6483-773c-9c27-ee10749f79d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-6483-773c-9c27-ee10749f79d4",
        "storage_key": "property/6767906449167227/019d0226-6483-773c-9c27-ee10749f79d4.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_7802581b-aecd-41ca-90d6-0d6b93bb0016",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Williwaw Social",
      "poi_type": "Entertainment",
      "poi_address": "609 F St, Anchorage, AK 99501, USA",
      "poi_short_description": "Multilevel destination featuring a casual American restaurant, a rooftop bar, a music venue & more.",
      "poi_long_description": "Multilevel destination featuring a casual American restaurant, a rooftop bar, a music venue & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-690b-750e-b24f-acc0204206f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-690b-750e-b24f-acc0204206f8",
        "storage_key": "property/6767906449167227/019d0226-690b-750e-b24f-acc0204206f8.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.williwawsocial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17982706632919555384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williwaw-social",
      "poi_latitude": "61.21633620000001",
      "poi_longitude": "-149.8931782",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-868-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b399-7661-a159-2bb3a2e4629f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b399-7661-a159-2bb3a2e4629f",
        "storage_key": "property/6767906449167227/019d0226-b399-7661-a159-2bb3a2e4629f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zaFASqWyFYROB07-2doj_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_e237ffe4-6e42-451d-a21c-581fba029773",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Cinemark Century Anchorage 16 and XD",
      "poi_type": "Entertainment",
      "poi_address": "301 E 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-691c-7198-8bb4-0f590405c08c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-691c-7198-8bb4-0f590405c08c",
        "storage_key": "property/6767906449167227/019d0226-691c-7198-8bb4-0f590405c08c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ak-anchorage/cinemark-century-anchorage-16-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5OTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722013179919255636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-century-anchorage-16-and-xd",
      "poi_latitude": "61.18909729999999",
      "poi_longitude": "-149.8792298",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-770-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdc1-72df-948e-4b7cdf1137d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdc1-72df-948e-4b7cdf1137d9",
        "storage_key": "property/6767906449167227/019d0226-bdc1-72df-948e-4b7cdf1137d9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxEYXseXyFYRVMh83mOGEOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_836ae699-e354-4b24-95b6-e2df35b2d880",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-6bbf-700b-a2dc-a65679ab3df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-6bbf-700b-a2dc-a65679ab3df5",
        "storage_key": "property/6767906449167227/019d0226-6bbf-700b-a2dc-a65679ab3df5.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7d4a9169-efa1-429c-a6ca-8df22e7bda7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-6e06-758a-90de-db1ed3778232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-6e06-758a-90de-db1ed3778232",
        "storage_key": "property/6767906449167227/019d0226-6e06-758a-90de-db1ed3778232.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 907-346-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_41cbbd0e-90fe-4630-bbc6-822a244f802c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Westchester Lagoon Nature Trail",
      "poi_type": "Entertainment",
      "poi_address": "#00115216000, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-6f47-77fb-989e-f63bc12cede1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-6f47-77fb-989e-f63bc12cede1",
        "storage_key": "property/6767906449167227/019d0226-6f47-77fb-989e-f63bc12cede1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://anchorageparkfoundation.org/westchester-lagoon-nature-trail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13991106944345741068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchester-lagoon-nature-trail",
      "poi_latitude": "61.20353489999999",
      "poi_longitude": "-149.9040874",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-274-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_y-wg-XyFYRDJc6SKNlKsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c44003e6-f971-4506-99d3-dab15625980e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Potter Marsh Wildlife Viewing Boardwalk",
      "poi_type": "Entertainment",
      "poi_address": "2999 E 154th Ave, Anchorage, AK 99516, USA",
      "poi_short_description": "Marsh featuring a boardwalk for wildlife viewing, plus a picnic area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-7298-7301-89bf-7425cffce02d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-7298-7301-89bf-7425cffce02d",
        "storage_key": "property/6767906449167227/019d0226-7298-7301-89bf-7425cffce02d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2031266168284876084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potter-marsh-wildlife-viewing-boardwalk",
      "poi_latitude": "61.0778438",
      "poi_longitude": "-149.8270566",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ853BIc-byFYRNI3jZNGBMBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_096fe77c-4b27-4e32-b6c0-2d58d0e1d668",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-7389-77ba-aacd-ef5554ab0744.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-7389-77ba-aacd-ef5554ab0744",
        "storage_key": "property/6767906449167227/019d0226-7389-77ba-aacd-ef5554ab0744.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1865955",
      "poi_longitude": "-149.8221279",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-be71-74e8-995d-56fadb56b1ce",
        "storage_key": "property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_85a4728c-ea24-4949-8114-e930df956901",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-77c8-7348-a7fa-e6f4a59125c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-77c8-7348-a7fa-e6f4a59125c6",
        "storage_key": "property/6767906449167227/019d0226-77c8-7348-a7fa-e6f4a59125c6.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-be71-74e8-995d-56fadb56b1ce",
        "storage_key": "property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bf5d32ad-2a49-4e39-94a2-8404e01c8363",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Providence ExpressCare - Tikahtnu Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1118 N Muldoon Rd Ste 130, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-754f-7399-af71-62e8631149cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-754f-7399-af71-62e8631149cc",
        "storage_key": "property/6767906449167227/019d0226-754f-7399-af71-62e8631149cc.webp",
        "width": 1173,
        "height": 660
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/expresscare-tikahtnu?Is=location&y_source=1_MTQ5MzE2OTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=569450515744697362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-expresscare---tikahtnu-urgent-care",
      "poi_latitude": "61.22750299999999",
      "poi_longitude": "-149.742738",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-227-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZnNOw-VyFYREiwgHDoY5wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_645c2f93-3c15-4950-8d9e-e151e1c5a56e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "AMS Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3401 Minnesota Dr #100, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-7bd8-7782-8f92-8751372e16c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-7bd8-7782-8f92-8751372e16c8",
        "storage_key": "property/6767906449167227/019d0226-7bd8-7782-8f92-8751372e16c8.webp",
        "width": 840,
        "height": 1280
      },
      "poi_business_url": "http://amsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805240541233911751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ams-urgent-care",
      "poi_latitude": "61.1891074",
      "poi_longitude": "-149.9123992",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-677-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwZ1h92XyFYRx5etW21atbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3822a4a1-ddb3-4d47-b555-65ee3d01da8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-47c8-7638-a302-7f3eff11f148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-47c8-7638-a302-7f3eff11f148",
        "storage_key": "property/6767906449167227/019d0226-47c8-7638-a302-7f3eff11f148.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/5600-debarr-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081271465743249979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.2081545",
      "poi_longitude": "-149.7770566",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-339-0960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c0b1-768b-a475-ef630c981a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c0b1-768b-a475-ef630c981a21",
        "storage_key": "property/6767906449167227/019d0226-c0b1-768b-a475-ef630c981a21.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRO3JAJDInLN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c31d6843-c000-4817-a9ef-9b5536ef0122",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7701 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-7a1e-73c8-b3c9-1789ac57d68b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-7a1e-73c8-b3c9-1789ac57d68b",
        "storage_key": "property/6767906449167227/019d0226-7a1e-73c8-b3c9-1789ac57d68b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00018?cid=loc_70100018P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13627735872385138461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.2114692",
      "poi_longitude": "-149.7368073",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-269-1733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c0b1-768b-a475-ef630c981a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c0b1-768b-a475-ef630c981a21",
        "storage_key": "property/6767906449167227/019d0226-c0b1-768b-a475-ef630c981a21.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCW78z6KWyFYRHT9dtpJxH70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7ae28561-fb3c-4252-afc7-c4af71095626",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "BR Fitness, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "7731 E Northern Lights Blvd #290, Anchorage, AK 99504, USA",
      "poi_short_description": "Members-only, 24-hour gym offering cardio machines, free weights, and personalized training programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-7ce3-74ab-8cab-80a97001b464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-7ce3-74ab-8cab-80a97001b464",
        "storage_key": "property/6767906449167227/019d0226-7ce3-74ab-8cab-80a97001b464.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://brfitnessalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719670159643573984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "br-fitness-llc",
      "poi_latitude": "61.1957096",
      "poi_longitude": "-149.7345466",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-206-2294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3Dph5eXyFYR4P6kmiDq6PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_85113f8f-b9a3-468f-90fa-f89502ae0eb2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "The Alaska Club East Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "5201 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-80cd-70af-8f42-21a25beb87e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-80cd-70af-8f42-21a25beb87e3",
        "storage_key": "property/6767906449167227/019d0226-80cd-70af-8f42-21a25beb87e3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-taceast-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13441179354482565633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-east-gym--pool",
      "poi_latitude": "61.181272",
      "poi_longitude": "-149.7830598",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-337-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8ujJiCXyFYRAWI_kmipiLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b15bd76b-91ef-4534-9ac5-1e1f9272ffd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Studio One VASIE® Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "4007 Old Seward Hwy # 900, Anchorage, AK 99503, USA",
      "poi_short_description": "Pilates studio offering workouts, classes, barre and bootcamps, along with rehab, strength and posture training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-80cd-70af-8f42-24dbb5bcac7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-80cd-70af-8f42-24dbb5bcac7a",
        "storage_key": "property/6767906449167227/019d0226-80cd-70af-8f42-24dbb5bcac7a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vasieonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=468324441195412692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-one-vasie-pilates",
      "poi_latitude": "61.1840217",
      "poi_longitude": "-149.8670886",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 702-708-2743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b858-712e-9acb-732830c166ab",
        "storage_key": "property/6767906449167227/019d0226-b858-712e-9acb-732830c166ab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT0w0d7yXyFYR1PwVFZnSfwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a34bf829-fff3-4f06-b785-c4556fe4ecfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Chanshtnu Muldoon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1301 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Family-friendly park offering picnic facilities, a restroom, a playground, and winter ice skating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8347-753f-a9b7-7fadd0d8fd1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8347-753f-a9b7-7fadd0d8fd1c",
        "storage_key": "property/6767906449167227/019d0226-8347-753f-a9b7-7fadd0d8fd1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://muldoonfarmersmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=446543973844265851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chanshtnu-muldoon-park",
      "poi_latitude": "61.208991",
      "poi_longitude": "-149.731189",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFz9TVbuWyFYReyuU2WBxMgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_abd14df1-8e01-44dc-b747-27b7526f5264",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Russian Jack Springs Park South",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 Lidia Selkregg Ln, Anchorage, AK 99508, USA",
      "poi_short_description": "Year-round, well-maintained park with cross-country trails and groomed hills for sledding, plus golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-82e6-705b-8b0d-d0b182e19e83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-82e6-705b-8b0d-d0b182e19e83",
        "storage_key": "property/6767906449167227/019d0226-82e6-705b-8b0d-d0b182e19e83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203965088416518130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russian-jack-springs-park-south",
      "poi_latitude": "61.2061283",
      "poi_longitude": "-149.7887878",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawU6nPSWyFYR8s-NWy_Em40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_208ebc23-d112-4da1-8482-b161d2859034",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Russian Jack Springs Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 Lidia Selkregg Ln, Anchorage, AK 99504, USA",
      "poi_short_description": "Casual 9-hole course with artificial turf, plus winter sledding and skiing options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-86ac-75aa-b011-deaf3333766e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-86ac-75aa-b011-deaf3333766e",
        "storage_key": "property/6767906449167227/019d0226-86ac-75aa-b011-deaf3333766e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Russian_Jack_Springs_Golf_Course.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14589512480617359771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russian-jack-springs-golf-course",
      "poi_latitude": "61.20746819999999",
      "poi_longitude": "-149.7835621",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-6992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c36a-74ca-95fb-c4b651c67104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c36a-74ca-95fb-c4b651c67104",
        "storage_key": "property/6767906449167227/019d0226-c36a-74ca-95fb-c4b651c67104.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJawU6nPSWyFYRm2lTdU1ceMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f679842d-1439-480c-b39e-ba8b9e4b74f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Cheney Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2245 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8737-72ea-9097-a9be7b5f5e50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8737-72ea-9097-a9be7b5f5e50",
        "storage_key": "property/6767906449167227/019d0226-8737-72ea-9097-a9be7b5f5e50.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659871588540635741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheney-lake-park",
      "poi_latitude": "61.200136",
      "poi_longitude": "-149.7630764",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJza3J7-qWyFYRXVq6V2oMCRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_bea39d43-629e-4bbf-9895-dc4955bdb996",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Nunaka Valley Park West",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5600 Perry Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9232076225128842235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nunaka-valley-park-west",
      "poi_latitude": "61.2068264",
      "poi_longitude": "-149.7766144",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfZVpPKWyFYR-0MiwmnsHoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5d95308f-bc7e-4d13-bb53-6c7c0851f267",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Turpin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 Oklahoma St, Anchorage, AK 99504, USA",
      "poi_short_description": "Dog-friendly park with a field and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8809-7791-956a-992b3ce8b5bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8809-7791-956a-992b3ce8b5bc",
        "storage_key": "property/6767906449167227/019d0226-8809-7791-956a-992b3ce8b5bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11191948199853467510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turpin-park",
      "poi_latitude": "61.221839",
      "poi_longitude": "-149.744627",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQQitZ2WyFYRdqfWHJfJUZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_370eb012-42b7-49e9-b5c7-be7e69724093",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Louis Peña Field, 8400 Starview Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-886e-77a8-b143-d6bfce9ed36a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-886e-77a8-b143-d6bfce9ed36a",
        "storage_key": "property/6767906449167227/019d0226-886e-77a8-b143-d6bfce9ed36a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15930121906186527767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "61.22896009999999",
      "poi_longitude": "-149.7225148",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0PaciGUyFYRF6Tq5ngpE90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_38e2228e-97d9-42c5-a234-c886c2d56bf0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Sitka Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1580 Sitka St Park, Anchorage, AK 99501, USA",
      "poi_short_description": "Local park with playground, picnic shelter & parking lot surrounded by greenery.",
      "poi_long_description": "Local park with playground, picnic shelter & parking lot surrounded by greenery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8cd1-75cc-bb75-675ebcf4cf29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8cd1-75cc-bb75-675ebcf4cf29",
        "storage_key": "property/6767906449167227/019d0226-8cd1-75cc-bb75-675ebcf4cf29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4965754320556807804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sitka-street-park",
      "poi_latitude": "61.2062655",
      "poi_longitude": "-149.8464076",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-73LUqWyFYRfFamrj7n6UQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_80bab37a-782c-484a-9cbe-e32f7cb41513",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Windsong Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1417 Carolyn Cir, Anchorage, AK 99504, USA",
      "poi_short_description": "Spacious, kid-friendly park featuring a playground for toddlers, plus a skate park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8d3f-7738-9c04-3e088fa9c155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8d3f-7738-9c04-3e088fa9c155",
        "storage_key": "property/6767906449167227/019d0226-8d3f-7738-9c04-3e088fa9c155.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2769464042083192408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsong-park",
      "poi_latitude": "61.2069229",
      "poi_longitude": "-149.724586",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0kuMaWWyFYRWA6Wft8cbyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2fab714f-c27d-4eaf-861f-0b099748a974",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Creekside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Creekside Park, 7122 E 6th Ave, Anchorage, AK 99504, USA",
      "poi_short_description": "Clean area for walking dogs, picnics and tennis, with basketball and baseball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8d12-75b5-8ae3-b6c3855fd1d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8d12-75b5-8ae3-b6c3855fd1d1",
        "storage_key": "property/6767906449167227/019d0226-8d12-75b5-8ae3-b6c3855fd1d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/ParksandTrails.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4977187822393065568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creekside-park",
      "poi_latitude": "61.21616350000001",
      "poi_longitude": "-149.7465223",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-bdbf-7088-a21e-b41fc4fa12f3",
        "storage_key": "property/6767906449167227/019d0226-bdbf-7088-a21e-b41fc4fa12f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlegOeJmWyFYRYIAjRvSFEkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ba0fcc5c-d64a-4406-bf62-9648ede0110c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Creekside Surgery Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3831 Piper St # S110, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-8e5e-7791-a817-c46a3a46b560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-8e5e-7791-a817-c46a3a46b560",
        "storage_key": "property/6767906449167227/019d0226-8e5e-7791-a817-c46a3a46b560.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.creeksideasc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014340471235935411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creekside-surgery-center",
      "poi_latitude": "61.1856258",
      "poi_longitude": "-149.8229082",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-339-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVZWTyFYRs_zVr5kV-oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3024abe2-fb0d-4b7a-95da-67527b8fd60b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-9358-762a-b26a-d3a34a63797c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-9358-762a-b26a-d3a34a63797c",
        "storage_key": "property/6767906449167227/019d0226-9358-762a-b26a-d3a34a63797c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.17707559999999",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_044dfd42-d62b-42a2-b129-abdf0ea0c9a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-9320-74d9-930c-3b9d22cc9000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-9320-74d9-930c-3b9d22cc9000",
        "storage_key": "property/6767906449167227/019d0226-9320-74d9-930c-3b9d22cc9000.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_05389074-458a-41e0-8431-c6d422e86408",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-94df-738b-bb7d-19093648eff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-94df-738b-bb7d-19093648eff3",
        "storage_key": "property/6767906449167227/019d0226-94df-738b-bb7d-19093648eff3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c374-76cd-b650-7efd2cf67795.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c374-76cd-b650-7efd2cf67795",
        "storage_key": "property/6767906449167227/019d0226-c374-76cd-b650-7efd2cf67795.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_5f29fb46-6288-4ac9-a4dc-2832016f46d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-9583-71ef-9f6e-0c84b15849f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-9583-71ef-9f6e-0c84b15849f8",
        "storage_key": "property/6767906449167227/019d0226-9583-71ef-9f6e-0c84b15849f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1d86eac0-6476-4568-9948-b1ab5718a9da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-a1ea-7246-9dff-1c97cb7ab9c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-a1ea-7246-9dff-1c97cb7ab9c7",
        "storage_key": "property/6767906449167227/019d0226-a1ea-7246-9dff-1c97cb7ab9c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c375-7518-b804-32e841474bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c375-7518-b804-32e841474bc3",
        "storage_key": "property/6767906449167227/019d0226-c375-7518-b804-32e841474bc3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_e8b7549a-d632-4ff3-b180-465d0638e24e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Airport South Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-9eab-757b-9f24-97095d1f5892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-9eab-757b-9f24-97095d1f5892",
        "storage_key": "property/6767906449167227/019d0226-9eab-757b-9f24-97095d1f5892.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14387890600298649866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "airport-south-terminal",
      "poi_latitude": "61.173144",
      "poi_longitude": "-149.979292",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c4fd-7459-85c5-210ee623c6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c4fd-7459-85c5-210ee623c6bb",
        "storage_key": "property/6767906449167227/019d0226-c4fd-7459-85c5-210ee623c6bb.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZ3l_62iyFYRCpn7SUUOrMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_2b43afaf-c539-4766-80da-1b88ce10ebff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-a19a-750f-bdd5-3f23c5f58674.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-a19a-750f-bdd5-3f23c5f58674",
        "storage_key": "property/6767906449167227/019d0226-a19a-750f-bdd5-3f23c5f58674.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_58200fa6-9e54-4bf4-b88d-0ec8b478b6cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-9eac-746b-bcf7-9df39f7b3b98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-9eac-746b-bcf7-9df39f7b3b98",
        "storage_key": "property/6767906449167227/019d0226-9eac-746b-bcf7-9df39f7b3b98.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2106829",
      "poi_longitude": "-149.8283619",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-be71-74e8-995d-56fadb56b1ce",
        "storage_key": "property/6767906449167227/019d0226-be71-74e8-995d-56fadb56b1ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a9cb8a18-b30e-4daa-b0eb-8ce33edf015b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Joint Base Elmendorf- Richardson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10471 20th St, Anchorage, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-a717-71cf-bdcf-756e2afc7ca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-a717-71cf-bdcf-756e2afc7ca8",
        "storage_key": "property/6767906449167227/019d0226-a717-71cf-bdcf-756e2afc7ca8.webp",
        "width": 1150,
        "height": 1280
      },
      "poi_business_url": "https://www.jber.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16361889729797625416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-base-elmendorf--richardson",
      "poi_latitude": "61.2464751",
      "poi_longitude": "-149.810681",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c71f-7158-9331-5cfc013faced.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c71f-7158-9331-5cfc013faced",
        "storage_key": "property/6767906449167227/019d0226-c71f-7158-9331-5cfc013faced.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28m2RyKVyFYRSBazLgUcEeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_71ed3355-6b62-45d6-b361-7c58d4a2408d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Hilcorp Alaska",
      "poi_type": "Major Employers & Offices",
      "poi_address": "JL Tower, 3800 Centerpoint Dr #1400, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-a747-744c-80d7-11ccb849bbe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-a747-744c-80d7-11ccb849bbe9",
        "storage_key": "property/6767906449167227/019d0226-a747-744c-80d7-11ccb849bbe9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hilcorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1231158791914635008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilcorp-alaska",
      "poi_latitude": "61.18589769999999",
      "poi_longitude": "-149.8915644",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-777-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERJxtsGXyFYRAL8r9mX0FRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36315cf1-3ec3-4755-99ae-e013220c169e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "ConocoPhillips Alaska",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 G St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-ab0a-775b-b4fe-d0f73d4257bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-ab0a-775b-b4fe-d0f73d4257bf",
        "storage_key": "property/6767906449167227/019d0226-ab0a-775b-b4fe-d0f73d4257bf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://alaska.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18204751589556885795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conocophillips-alaska",
      "poi_latitude": "61.215194",
      "poi_longitude": "-149.8962402",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-276-1215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-b989-7251-8dd7-ac82e725601a",
        "storage_key": "property/6767906449167227/019d0226-b989-7251-8dd7-ac82e725601a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9x13m4C9yFYRIxnEJx5FpPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e7aa481c-e26a-42e3-83ea-a45a4fb16c60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-a954-7776-9e70-5ac8873f0f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0226-a954-7776-9e70-5ac8873f0f38",
        "storage_key": "property/6767906449167227/019d0226-a954-7776-9e70-5ac8873f0f38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019d0226-c71f-7158-9331-5cfc013faced.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0226-c71f-7158-9331-5cfc013faced",
        "storage_key": "property/6767906449167227/019d0226-c71f-7158-9331-5cfc013faced.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bd5544e80d5088b8662a4a97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b9281053b1cd70b9a84dbd4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_de9b17639aec435f43e315a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f321c8b9dc460d6afdbc5f87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6e2648b32eebd2928d9d5749",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_5cd66c0d8f8b0328242c28c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "rating": "5",
      "name": "Kareem Waugh",
      "text": "Britany sorry your moving on you'll be missed you were lots of fun and very easy to work with and very professional you help me with all my needs I m sure am going to miss the energy you. Your very caring and can change the energy in the room. Good luck on your next journey..",
      "date": "2026-05-18",
      "title": "false"
    },
    {
      "id": "ec_3fed19741c698944408fd188",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "rating": "5",
      "name": "C-tina Chapa",
      "text": "Britany in the leasing office was so helpful and accommodating. Very friendly and informative. She has a warm and welcoming  personality.  Made our experience at Legacy West very positive. I definitely recommend dealing with her.",
      "date": "2025-11-08",
      "title": "false"
    },
    {
      "id": "ec_0cd5d0a0a53d78aa700aab96",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "rating": "5",
      "name": "Wiseman Elick",
      "text": "I would like to express my heartfelt appreciation to Maggie at Legacy Apartments for her professionalism at her job. Her customer service is unmatched to all I’ve experienced from the telephone call I made to inquire, assistance with my online application, tour of the apartment, payments, and the handing over the apartment but most of all for doing an amazing job to get me approved to move in within 24hours. This amazing work ethics should be rewarded and should not go unrewarded.",
      "date": "2025-09-12",
      "title": "false"
    },
    {
      "id": "ec_9a2796b08bf6b6537f3c96ac",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "rating": "5",
      "name": "Yin Yoru",
      "text": "Maggie was very helpful getting the apartment ready for my move in, she was very patient when I asked for the endless tours of every apartment they had available, and helped me choose a preferred apartment after I overlooked a crucial detail in the apartment I would have chosen on my own. Did a great job! I look forward to making this place a home 😊",
      "date": "2025-08-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_3982ec20a3683519b1e6b4fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019ddcfb-96d7-755a-9a59-99ca0b65888d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfb-96d7-755a-9a59-99ca0b65888d",
        "storage_key": "property/6767906449167227/019ddcfb-96d7-755a-9a59-99ca0b65888d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7ZKqkKX18dq"
    },
    {
      "id": "ec_0ae1f626faf3f9388f43785b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167227/019ddcfb-967b-7729-a728-8580b4c18136.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfb-967b-7729-a728-8580b4c18136",
        "storage_key": "property/6767906449167227/019ddcfb-967b-7729-a728-8580b4c18136.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3x1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=n4AqSWFG3pp"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0b0d0-7d15-74b0-b049-14e76a189fbc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Legacy West Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "in-home-washer-dryer-apartments-anchorage-ak",
      "search_query": "apartments with in-home washer dryer anchorage ak",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer Dryer",
      "h2_subtitle": "Enjoy the convenience of in-home washer dryer in Anchorage AK at Legacy West. Embrace easy living with our spacious apartments and essential amenities.",
      "page_copy": "Discover the convenience of apartments with in-home washer dryer in Anchorage AK, nestled in the inviting setting of Legacy West. Our community offers roomy two- and three-bedroom options that ensure ample living space while providing mountain views from select units. Imagine effortlessly tackling laundry day without leaving the comfort of your own home. \n\nBeyond the in-home conveniences, Legacy West presents a location perfect for those wanting room to breathe in Northeast Anchorage. Our community is enhanced by a keyed access building, on-site maintenance services, and picturesque views of the Chugach Mountain Range. Experience a seamless blend of comfort and utility at Legacy West — your next home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Home Washer Dryer in Anchorage",
      "seo_description": "Legacy West offers apartments in Anchorage AK equipped with in-home washers and dryers plus stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "smoke-free-community-northeast-anchorage",
      "search_query": "smoke free community in northeast anchorage",
      "category": "Amenity",
      "h1_title": "Smoke-Free Living in Northeast Anchorage",
      "h2_subtitle": "Discover a serene, smoke-free community in Northeast Anchorage at Legacy West. Find your perfect home with spacious layouts and modern amenities.",
      "page_copy": "Welcome to a smoke-free community in Northeast Anchorage at Legacy West, where you can enjoy a healthy living environment in spacious two- and three-bedroom apartments. Our community is designed for residents who appreciate the importance of fresh air and tranquil surroundings, paired with a wide array of amenities that enhance everyday life.\n\nLegacy West offers more than just a smoke-free space; it provides residents with modern conveniences such as in-home washers and dryers and picturesque views of the Chugach Mountain Range from select units. The convenience of on-site maintenance and secured access is an added bonus, ensuring that peace of mind and comfort are constants in your day-to-day life. Experience the best of Northeast Anchorage living in a community committed to wellness and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Community in Northeast Anchorage",
      "seo_description": "Experience a smoke-free community in Northeast Anchorage at Legacy West, offering spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "anchorage-apartments-mountain-view-patios",
      "search_query": "anchorage apartments with mountain view patios",
      "category": "Amenity",
      "h1_title": "Anchorage Apartments with Mountain View",
      "h2_subtitle": "Enjoy panoramic mountain views from your patio at Legacy West. Experience the beauty of Anchorage right outside your home.",
      "page_copy": "Experience the best of Alaska's natural beauty with our Anchorage apartments with mountain view patios at Legacy West. Situated in Northeast Anchorage, our community offers breathtaking sights of the Chugach Mountain Range from select units, providing the perfect backdrop for your daily relaxation. Our two- and three-bedroom apartments are designed to maximize your comfort and connection to nature.\n\nLegacy West allows you to enjoy panoramic mountain views along with essential amenities such as in-home washer/dryer, on-site maintenance, and a secure, keyed access building. Embrace the blend of serenity and convenience, making Legacy West an ideal place to call home. Discover a unique living experience where stunning landscapes meet practical living solutions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Apartments with Mountain View Patios",
      "seo_description": "Enjoy stunning views of the Chugach Mountains from patios at Legacy West. Find spacious Anchorage apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "legacy-west-apartments-walk-in-closets",
      "search_query": "legacy west apartments with walk-in closets",
      "category": "Amenity",
      "h1_title": "Legacy West: Apartments with Walk-In Closets",
      "h2_subtitle": "Discover ample storage with walk-in closets at Legacy West apartments. Experience the perfect blend of space and convenience in Anchorage.",
      "page_copy": "Discover the ideal blend of spacious living and thoughtful design at Legacy West, where our apartments feature walk-in closets that meet all your storage needs. Located in beautiful Northeast Anchorage, our community offers two- and three-bedroom floor plans with modern amenities for a comfortable lifestyle. Enjoy the luxury of organized living with plenty of room to breathe.\n\nIn addition to ample storage, Legacy West provides residents with stunning views of the Chugach Mountain Range, in-home washers and dryers, and a securely accessed building. Our middle-floor units ensure privacy while the on-site maintenance team provides peace of mind. At Legacy West, you'll find a welcoming environment that's both functional and picturesque—your perfect next home in Anchorage.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Legacy West Apartments with Walk-In Closets",
      "seo_description": "Legacy West in Anchorage offers spacious apartments with walk-in closets and modern amenities for the ideal living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-with-fireplace-anchorage-municipality",
      "search_query": "apartments with fireplace anchorage municipality",
      "category": "Amenity",
      "h1_title": "Cozy Anchorage Apartments with Fireplaces",
      "h2_subtitle": "Warm up in style in Anchorage Municipality with apartments that feature fireplaces. Experience comfort and convenience at Legacy West.",
      "page_copy": "Find warmth and comfort in Anchorage Municipality with apartments that come equipped with inviting fireplaces. While Legacy West provides a spacious setting with modern conveniences, our current offerings focus on maximizing your living experience with other exceptional amenities. Enjoy the views of the Chugach Mountain Range from select units, offering a scenic backdrop for daily living.\n\nAt Legacy West, located in Northeast Anchorage, you will find in-home washers and dryers, impressive middle-floor views, and keyed access buildings ensuring security and ease of access. Our community combines the tranquility of nature with the functionality of modern living, making it a prime choice for those seeking a place to call home in Anchorage Municipality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Municipality Apartments with Fireplaces",
      "seo_description": "Discover cozy Anchorage Municipality apartments featuring fireplaces. Legacy West offers a perfect blend of comfort and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-northeast-anchorage",
      "search_query": "two bedroom apartments northeast anchorage",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Northeast Anchorage",
      "h2_subtitle": "Explore spacious two-bedroom layouts at Legacy West in Northeast Anchorage. Experience a blend of comfort and stunning mountain views.",
      "page_copy": "Located in the heart of Northeast Anchorage, Legacy West offers two-bedroom apartments designed for both comfort and style. Each apartment provides ample space complemented by modern amenities like in-home washers and dryers, and select units feature breathtaking views of the Chugach Mountain Range. Our community provides a serene environment while ensuring you're well-connected to Anchorage Municipality's conveniences.\n\nLegacy West not only offers spacious interiors but also cares about security with secure key access and dependable on-site maintenance services. Our thoughtfully designed two-bedroom layouts enable plenty of room for personal expression and comfort. Find your ideal living space where serene natural beauty meets contemporary convenience, right here at Legacy West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Northeast Anchorage",
      "seo_description": "Discover spacious two-bedroom apartments at Legacy West in Northeast Anchorage, featuring modern amenities and scenic mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-anchorage-municipality",
      "search_query": "three bedroom apartments anchorage municipality",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Anchorage Municipality",
      "h2_subtitle": "Discover ample living space with our three-bedroom apartments in Anchorage Municipality. Legacy West offers comfort and modern amenities for families and roommates alike.",
      "page_copy": "Offering spacious three-bedroom apartments, Legacy West is an ideal choice for families and those needing extra space within Anchorage Municipality. Nestled in Northeast Anchorage, our community merges convenience with contemporary living, featuring in-home washers and dryers and scenic views of the Chugach Mountain Range. Every apartment is designed to maximize comfort and functional living.\n\nSafety and convenience are key at Legacy West, with secure keyed access and 24/7 on-site maintenance. Whether you desire room to stretch out or a community that feels like home, our three-bedroom layouts provide a perfect base to personalize your living experience. Experience the ideal mix of modern amenities and natural beauty at Legacy West, your future home in Anchorage Municipality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Anchorage Municipality",
      "seo_description": "Explore spacious three-bedroom apartments in Anchorage Municipality at Legacy West, featuring views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-near-chester-valley-elementary-school",
      "search_query": "apartments near Chester Valley Elementary School Anchorage",
      "category": "School",
      "h1_title": "Apartments Near Chester Valley Elementary School",
      "h2_subtitle": "Find conveniently situated apartments near Chester Valley Elementary School in Anchorage. Legacy West offers comfort, community, and educational proximity.",
      "page_copy": "Legacy West offers ideal living options for families seeking proximity to Chester Valley Elementary School in Anchorage. Located in Northeast Anchorage, our apartments provide an easy commute and a warm community atmosphere. The spacious two- and three-bedroom layouts are perfect for those prioritizing comfort and convenience, featuring amenities like in-home washers and dryers.\n\nApart from its prime location, Legacy West enhances your living experience with exceptional services, including on-site maintenance and keyed access for security. Enjoy partial mountain views of the Chugach Range, adding a touch of natural beauty to your daily life. Choose Legacy West for a home that balances education accessibility with family-friendly amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chester Valley Elementary School",
      "seo_description": "Find family-friendly apartments near Chester Valley Elementary School in Anchorage at Legacy West, offering modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-close-to-scenic-park-elementary",
      "search_query": "apartments close to Scenic Park Elementary School Northeast Anchorage",
      "category": "School",
      "h1_title": "Apartments Close to Scenic Park Elementary",
      "h2_subtitle": "Explore well-positioned apartments close to Scenic Park Elementary School in Northeast Anchorage. Legacy West combines comfort with school proximity.",
      "page_copy": "Situated in Northeast Anchorage, Legacy West presents an attractive option for families looking to reside near Scenic Park Elementary School. Our spacious two- and three-bedroom apartments offer a contemporary living experience with amenities such as in-home washers and dryers, providing everyday convenience. Enjoy stunning views of the Chugach Mountain Range from select units, making your home feel both welcoming and serene.\n\nLegacy West not only boasts an ideal location near Scenic Park Elementary but also ensures community safety with secure keyed access. Responsive on-site maintenance is also available, enhancing the smooth living experience. If you prioritize both educational accessibility and modern comforts, Legacy West is the perfect place to call home in Anchorage Municipality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Scenic Park Elementary School",
      "seo_description": "Discover conveniently located apartments near Scenic Park Elementary in Northeast Anchorage at Legacy West, complete with modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "living-near-baxter-elementary-school-99504",
      "search_query": "living near Baxter Elementary School 99504",
      "category": "School",
      "h1_title": "Living Near Baxter Elementary School",
      "h2_subtitle": "Experience the benefits of living near Baxter Elementary School in the 99504 area. Legacy West is your gateway to a family-friendly community.",
      "page_copy": "Legacy West provides an excellent living option for families who want to reside near Baxter Elementary School in the 99504 area. Our two- and three-bedroom apartments are designed for comfort and convenience, equipped with in-home washers and dryers and offering scenic Chugach Mountain views. This makes them perfect for families seeking a balance of functionality and style in their home.\n\nLocated in the heart of Northeast Anchorage, Legacy West ensures a secure and pleasant environment with keyed access and a committed on-site maintenance team. Choosing our community means enjoying the peace of mind that comes with an ideal location near excellent schools and everyday comforts. Embrace family-friendly living at Legacy West, your future home near Baxter Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Baxter Elementary School 99504",
      "seo_description": "Experience living near Baxter Elementary School in the 99504 area at Legacy West. Enjoy spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "rental-homes-by-ptarmigan-elementary-school",
      "search_query": "rental homes by Ptarmigan Elementary School Anchorage Municipality",
      "category": "School",
      "h1_title": "Rental Homes by Ptarmigan Elementary School",
      "h2_subtitle": "Discover comfortable rental homes by Ptarmigan Elementary School within Anchorage Municipality. Legacy West offers both location and lifestyle.",
      "page_copy": "Located within the Anchorage Municipality, Legacy West is perfectly suited for those seeking rental homes near Ptarmigan Elementary School. Our community offers spacious two- and three-bedroom units equipped with modern amenities like in-home washers and dryers, ensuring convenience and comfort in every corner of your home. Select apartments also feature views of the stunning Chugach Mountains, adding a serene touch to your living experience.\n\nAt Legacy West, you can enjoy the peace of mind that comes with living in a secure environment, thanks to our keyed access building. Additionally, our on-site maintenance team is always ready to assist, ensuring your home remains in top condition. Choose Legacy West for a family-friendly atmosphere where convenience meets beauty, all within a short distance from Ptarmigan Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes by Ptarmigan Elementary School",
      "seo_description": "Find rental homes near Ptarmigan Elementary School in Anchorage Municipality at Legacy West. Enjoy modern amenities and a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "legacy-west-near-begich-middle-school",
      "search_query": "Legacy West near Begich Middle School in Anchorage",
      "category": "School",
      "h1_title": "Legacy West Near Begich Middle School",
      "h2_subtitle": "Find your new home at Legacy West, conveniently located near Begich Middle School in Anchorage. Experience spacious living with stunning amenities.",
      "page_copy": "Legacy West offers an ideal living solution for families with students attending Begich Middle School in Anchorage. Our community provides spacious two- and three-bedroom apartments designed with everyday comforts in mind. Each unit features in-home washers and dryers for ultimate convenience, ensuring that your home life runs smoothly.\n\nNestled in Northeast Anchorage, Legacy West not only provides proximity to Begich Middle School but also offers breathtaking views of the Chugach Mountain Range from select apartments. With a secure keyed access building and attentive on-site maintenance, residents enjoy peace of mind and quality service. Experience the blend of location and lifestyle at Legacy West, where comfort meets convenience in Anchorage.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Legacy West Near Begich Middle School",
      "seo_description": "Explore Legacy West, located near Begich Middle School in Anchorage. Enjoy spacious layouts and stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "bartlett-high-school-nearby-apartments",
      "search_query": "Bartlett High School nearby apartments in Northeast Anchorage",
      "category": "School",
      "h1_title": "Apartments Near Bartlett High School",
      "h2_subtitle": "Discover spacious apartments near Bartlett High School in Northeast Anchorage. Legacy West offers comfort and convenience for your family.",
      "page_copy": "Situated in Northeast Anchorage, Legacy West provides a perfect choice for those looking for apartments near Bartlett High School. Our community features generously sized two- and three-bedroom layouts, catering to families seeking both space and convenience. Residents enjoy modern amenities, including in-home washers and dryers, making daily living hassle-free.\n\nLegacy West is not just about location—our apartments offer views of the Chugach Mountains and a secure living environment through keyed access buildings. With reliable on-site maintenance, residents can experience both comfort and peace of mind. Choose Legacy West for a welcoming community where stunning natural beauty meets practicality, all just moments from Bartlett High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bartlett High School",
      "seo_description": "Find spacious apartments near Bartlett High School in Northeast Anchorage at Legacy West. Enjoy modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-around-anchorage-waldorf-school",
      "search_query": "apartments around Anchorage Waldorf School Anchorage",
      "category": "School",
      "h1_title": "Apartments Near Anchorage Waldorf School",
      "h2_subtitle": "Discover quality apartments near Anchorage Waldorf School in Anchorage. Legacy West offers both location and essential comforts.",
      "page_copy": "Legacy West is an excellent choice for those seeking apartments near Anchorage Waldorf School. Located in Anchorage Municipality, our community provides residents with spacious two- and three-bedroom layouts designed for comfort and convenience. Each apartment is equipped with in-home washers and dryers, streamlining daily chores and enhancing your living experience.\n\nEnjoy scenic views of the Chugach Mountains from select units and benefit from a secure living environment, thanks to our keyed access building and diligent on-site maintenance. Legacy West is the perfect blend of practicality and beauty, offering an ideal setting for families who prioritize both education and lifestyle. Explore Legacy West, where proximity to Anchorage Waldorf School meets modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Anchorage Waldorf School",
      "seo_description": "Explore Legacy West apartments near Anchorage Waldorf School. Experience spacious living and modern amenities in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-alaska-anchorage",
      "search_query": "find apartments close to University of Alaska Anchorage",
      "category": "School",
      "h1_title": "Find Apartments Near University of Alaska",
      "h2_subtitle": "Explore spacious apartments close to the University of Alaska Anchorage. Enjoy comfortable living with stunning views at Legacy West.",
      "page_copy": "If you're looking to find apartments close to the University of Alaska Anchorage, consider Legacy West in Northeast Anchorage. Our community offers spacious two- and three-bedroom apartments, all equipped with modern conveniences like in-home washers and dryers. This ensures a hassle-free lifestyle as you focus on your academic pursuits.\n\nLegacy West boasts stunning views of the Chugach Mountain Range from select units, providing a serene backdrop to your college experience. With keyed access buildings and responsive on-site maintenance, you'll have peace of mind knowing you live in a secure, well-maintained environment. Discover the ideal blend of location and lifestyle at Legacy West, where accessibility and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near University of Alaska",
      "seo_description": "Legacy West offers spacious living close to the University of Alaska Anchorage with modern amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-near-providence-alaska-medical-center",
      "search_query": "apartments near Providence Alaska Medical Center Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence Alaska Medical Center",
      "h2_subtitle": "Explore modern apartments near Providence Alaska Medical Center in Anchorage. Legacy West offers convenience and comfort in well-designed layouts.",
      "page_copy": "Searching for apartments near Providence Alaska Medical Center? Legacy West, located in Northeast Anchorage, provides the perfect blend of comfort and convenience. Our spacious two- and three-bedroom apartments are ideal for healthcare professionals and hospital visitors seeking proximity without compromising on space.\n\nEach apartment is designed with everyday ease in mind, featuring amenities like in-home washers and dryers and keyed access buildings for added security. Residents can also enjoy beautiful views of the Chugach Mountain Range, making it a peaceful retreat after a busy day. Trust Legacy West to deliver a living experience where work and relaxation harmoniously coexist, all just a short distance from Providence Alaska Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence Alaska Medical Center",
      "seo_description": "Discover Legacy West, offering spacious apartments near Providence Alaska Medical Center in Anchorage with modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "legacy-west-close-to-alaska-native-medical-center",
      "search_query": "Legacy West Anchorage close to Alaska Native Medical Center",
      "category": "Hospital",
      "h1_title": "Legacy West near Alaska Native Medical Center",
      "h2_subtitle": "Experience comfort at Legacy West, conveniently close to Alaska Native Medical Center in Anchorage. Enjoy well-appointed living spaces and stunning vistas.",
      "page_copy": "For those seeking a home close to the Alaska Native Medical Center, Legacy West offers an ideal location just a short drive away. Nestled in Northeast Anchorage, Legacy West boasts sophisticated two- and three-bedroom apartments that promise both comfort and accessibility.\n\nOur community provides essential amenities such as in-home washers and dryers and secure keyed access buildings, ensuring peace of mind for all residents. Marvel at the Chugach Mountain Range from select units while enjoying a spacious layout tailored for modern living. Choose Legacy West for its perfect balance of location, comfort, and convenience, all within reach of the Alaska Native Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Legacy West Near Alaska Native Medical Center",
      "seo_description": "Explore Legacy West in Anchorage, close to Alaska Native Medical Center with spacious apartments and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-near-chanshtnu-muldoon-park-anchorage",
      "search_query": "apartments near chanshtnu muldoon park anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Chanshtnu Muldoon Park",
      "h2_subtitle": "Discover the serenity of apartments near Chanshtnu Muldoon Park in Anchorage. Legacy West offers convenience and stunning mountain views.",
      "page_copy": "Looking for apartments near Chanshtnu Muldoon Park in Anchorage? Legacy West is a prime choice, offering spacious two- and three-bedroom apartments in Northeast Anchorage. Enjoy the park's recreational opportunities and beautiful natural surroundings just minutes from home.\n\nLegacy West caters to modern living needs with in-home washers and dryers, ensuring a comfortable lifestyle. Security and convenience are priorities with our keyed access buildings and responsive on-site maintenance. Take advantage of select units with sweeping views of the Chugach Mountain Range, and relish the perfect blend of outdoor access and indoor comfort. Choose Legacy West for unparalleled proximity to Chanshtnu Muldoon Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chanshtnu Muldoon Park, Anchorage",
      "seo_description": "Explore Legacy West for spacious living near Chanshtnu Muldoon Park in Anchorage, offering modern amenities and majestic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-close-to-russian-jack-springs-park",
      "search_query": "apartments close to russian jack springs park south northeast anchorage",
      "category": "Park",
      "h1_title": "Apartments Close to Russian Jack Springs Park",
      "h2_subtitle": "Find serenity in apartments close to Russian Jack Springs Park in South Northeast Anchorage. Legacy West offers spacious living just minutes away.",
      "page_copy": "Discover the perfect residential area close to Russian Jack Springs Park in South Northeast Anchorage. Legacy West provides two- and three-bedroom apartments designed for those who crave both natural beauty and modern comforts.\n\nOur community is not only a stone's throw from the scenic park but also offers modern in-home conveniences like washers and dryers. With secure keyed access and attentive on-site maintenance, residents enjoy both safety and ease of living. Select units feature breathtaking views of the Chugach Mountain Range, blending outdoor scenery with indoor tranquility. Choose Legacy West for the best in park-side living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Russian Jack Springs Park",
      "seo_description": "Live near Russian Jack Springs Park at Legacy West in Anchorage. Enjoy spacious apartments and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167227",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-anchorage-airport",
      "search_query": "apartments near ted stevens anchorage airport",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens Anchorage Airport",
      "h2_subtitle": "Convenient living awaits at Legacy West, just a short drive from Ted Stevens Anchorage Airport. Choose comfort and accessibility in Anchorage.",
      "page_copy": "For those needing proximity to Ted Stevens Anchorage Airport, Legacy West offers a convenient location combined with comfortable living options. Situated in Northeast Anchorage, our two- and three-bedroom apartments are designed for both short-term visitors and long-term residents seeking easy access to the airport.\n\nLegacy West provides everything you need for a worry-free lifestyle, including in-home washers and dryers and secure keyed access. Enjoy the peace of mind with our on-site maintenance team always ready to assist. Select units offer picturesque views of the Chugach Mountain Range, making every day feel like a retreat. Choose Legacy West for an ideal home near the airport with all the essentials you need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, a double sink, and a window.",
        "public_id": "019d0225-3093-740a-8066-ac89192cdc59",
        "storage_key": "property/6767906449167227/019d0225-3093-740a-8066-ac89192cdc59.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens Anchorage Airport",
      "seo_description": "Discover Legacy West, just minutes from Ted Stevens Anchorage Airport, offering comfort and convenience in spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309690144"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085343"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MSWF4LW9"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/43b69e02-45bb-4e43-b821-cf0ec5962c8e/app.js?property=43b69e02-45bb-4e43-b821-cf0ec5962c8e&propertyName=Legacy+West&channelUuid=c2490113-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47749960619"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImczZ2dXR1lUN3RSQlFHSEdoYWlQN1E9PSIsInZhbHVlIjoiVm9tVjNtMlNpTVJ5ajloRThPTUM5QT09IiwibWFjIjoiNGNjZGFiYmE4ZjNiNjdlY2NmZDJhYTk1OTAzMGQxYTg3NGVlYTU2ZDc4OTcyMTY5MGVhMTBkODAwODQyN2UxNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309690144",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085343",
  "custom_google_gtm_id": "GTM-MSWF4LW9",
  "custom_rollout_phase": "Phase 7.2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/43b69e02-45bb-4e43-b821-cf0ec5962c8e/app.js?property=43b69e02-45bb-4e43-b821-cf0ec5962c8e&propertyName=Legacy+West&channelUuid=c2490113-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47749960619",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImczZ2dXR1lUN3RSQlFHSEdoYWlQN1E9PSIsInZhbHVlIjoiVm9tVjNtMlNpTVJ5ajloRThPTUM5QT09IiwibWFjIjoiNGNjZGFiYmE4ZjNiNjdlY2NmZDJhYTk1OTAzMGQxYTg3NGVlYTU2ZDc4OTcyMTY5MGVhMTBkODAwODQyN2UxNCJ9",
  "custom_audioeye_site_id": "c3fa45be-3b80-414e-a78f-dc245d62d81e",
  "custom_audioeye_site_hash": "7de5ea19f7a4ac0fdb8bfb264f389d29"
};

export const generatedAt = '2026-10-29T23:14:19.925Z';
